export enum BulkUploadType {
  VEHICLE = 'VEHICLE',
  PRACTITIONER = 'PRACTITIONER',
  PREMIS = 'PREMIS',
}